/**
 * Breakpoints (responsive widths) from Figma (Queen One Design System).
 * Source: Breakpoints variable collection.
 * Values in px.
 */

export const breakpoints = {
  xs: 0,
  s: 444,
  sm: 600,
  md: 900,
  lg: 1200,
  xl: 1536,
} as const;
